// DS: i5.9
import React from 'react';
import IconWrap from '../../IconWrap';
const Add = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10.58 3.484c-.393.3-.58.655-.58 1.016V5a1 1 0 01-2 0v-.5c0-1.136.612-2.031 1.369-2.607A4.437 4.437 0 0112 1c.92 0 1.883.323 2.631.893C15.388 2.469 16 3.363 16 4.5V5a1 1 0 11-2 0v-.5c0-.361-.187-.717-.58-1.016A2.44 2.44 0 0012 3a2.44 2.44 0 00-1.42.484zM13 14.7a1 1 0 10-2 0v1.7a1 1 0 102 0v-1.7z"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M12.664 22.752l8-5.84a.974.974 0 00.336-.734v-5.876a.978.978 0 00-.485-.842l-3.938-2.32a1.015 1.015 0 00-1.115.056L12 9.746l-3.462-2.55a1.015 1.015 0 00-1.115-.056L3.485 9.46a.978.978 0 00-.485.842v5.876c0 .28.122.548.336.734l8 5.84c.378.33.95.33 1.328 0zM5 15.652l7 5.109 7-5.11V10.89l-2.877-1.695L12 12.23 7.877 9.194 5 10.889v4.762z",
        clipRule: "evenodd"
    })));
};
Add.displayName = 'Add';
export default Add;

//# sourceMappingURL=Private.js.map